var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nx-no-data"},[_c('nx-image',{staticClass:"img",attrs:{"width":"130px","height":"130px","src":require('@/assets/images/icon/noData.png')}}),_c('p',{staticClass:"text"},[_vm._v("暂无查询结果")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }